<script>
import Header from "@/components/Header.vue";
import CreateTask from "@/components/PlayList/CreateTask.vue";
export default {
  name: "Playlists",
  components: {Header, CreateTask}
}
</script>

<template>
<div>
  <Header>
    <button class="btn btn-primary">Создать плейлист</button>
  </Header>

</div>
</template>

<style scoped>
.btn {
  font: 400 10pt "Golos Text", "Open Sans", "Segoe UI", "Liberation Sans", sans-serif;
  background: #888;
  color: #fff;
  border: 0;
  border-radius: 3px;
  padding: 5px 10px;
  vertical-align: bottom;
  min-width: 120px;
  cursor: pointer;
  display: inline-block;
  text-decoration: none;
}
.btn-primary{
  background-color: #6c8;
  transition: .3s ease-in-out all;
  margin-right: 5px;
}
</style>